export default {
    setEngagementQueues(state, payload) {
      state.engagementQueues = payload;
    },
    setEngagementQueueSourceFeeders(state, payload) {
      state.engagementQueueSourceFeeders = payload;
    },
    setEngagementQueueDetail(state, payload) {
        state.engagementQueueDetail = payload;
      },
  };
  